import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NavLink from "../NavLink";
import { useIntl } from "react-intl";
import PageRoute from "../../../constant/pageRouteDictionary.json";

const useStyles = makeStyles(theme =>
  createStyles({
    menuPaper: {
      marginTop: 35,
    },
    menuItem: {
      fontSize: 12,
      textTransform: "uppercase",
      fontWeight: 600,
    },
  })
);

const NavMenu = ({ menu, onWorkspaceClick }) => {
  const intl = useIntl();
  const classes = useStyles();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  // find current page key based on pathname
  const currentPage = Object.keys(PageRoute).find(
    key => PageRoute[key] === location.pathname
  );

  const handleClick = event => {
    if (menu.childMenu && menu.childMenu.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNonOverviewLink = () => {
    if (menu.page === "workspaceOverview") {
      return () => {
        if (onWorkspaceClick) {
          onWorkspaceClick();
        }
      };
    }
    return handleClose;
  };

  return (
    <>
      <NavLink
        label={menu.name?.trim() || intl.formatMessage({ id: `pageKey.${menu.page}` })}
        hasChild={Boolean(menu.childMenu && menu.childMenu.length > 0)}
        open={Boolean(anchorEl)}
        link={PageRoute[menu.page] || "/"}
        onClick={handleNonOverviewLink()}
        selected={currentPage === menu.page}   // 🔹 highlight top-level
      />

      {menu.childMenu && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          classes={{ paper: classes.menuPaper }}
        >
          {menu.childMenu.map((x, idx) => (
            <MenuItem
              key={`navmenu-${idx}`}
              onClick={handleClose}
              className={classes.menuItem}
            >
              <NavLink
                label={x.name?.trim() || intl.formatMessage({ id: `pageKey.${x.page}` })}
                link={PageRoute[x.page] || "/"}
                selected={currentPage === x.page}   // 🔹 highlight child
              />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

NavMenu.propTypes = {
  menu: PropTypes.shape({
    name: PropTypes.string,
    page: PropTypes.string.isRequired,
    childMenu: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        page: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
  onWorkspaceClick: PropTypes.func,
  pageRoutes: PropTypes.object.isRequired,
};

NavMenu.defaultProps = {
  onWorkspaceClick: null,
};

export default NavMenu;
